import React from "react";
import { useSortBy } from "web/react/hooks/filters/use-sort-by";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { FilterSection } from "./filter-section";
import { MenuItemRadio } from "./menu-item-radio";

export function SortBy(): JSX.Element {
    const { sortBy, items, onChange } = useSortBy();

    function handleClick(item): void {
        onChange(item.value);

        // Fire Analytics
        analytics.event("sort_by", item.analyticsLabel);
    }

    return (
        <FilterSection title={gettext("feed.filters.sort_by")}>
            {items.map((item) => (
                <MenuItemRadio
                    key={item.value}
                    item={item}
                    onClick={handleClick}
                    isChecked={item.value === sortBy}
                />
            ))}
        </FilterSection>
    );
}
